import React from "react";
import { useNavigate } from "react-router-dom";
import TaskerList from "./TaskerList";
import { Button, Title, Container, Group, Text } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";

const Tasker = () => {
    const navigate = useNavigate();

    return (
        <Container size="xl">
            <Group justify="space-between" mb="md">
                <div><Title order={2}>Tasker</Title><Text c="dimmed" mt={5}>Team requests, progress and deliverables.</Text></div>
                <Button
                    leftSection={<IconPlus size={14} />}
                    onClick={() => navigate("/tasker/create")}
                >
                    Add Task
                </Button>
            </Group>
            <TaskerList />
        </Container>
    );
};

export default Tasker;
